import { ApplicationSelectors } from '../store/application/application.selectors';
import { Store } from '@ngxs/store';

export class DynamicLocaleId extends String {
  constructor(protected store: Store) {
    super('');
  }

  override toString() {
    return this.store
      .selectSnapshot(ApplicationSelectors.language)
      .toString()
      .toLowerCase();
  }
}
